<template>
  <div>
    <BreadCrumbs />
    <Content />
  </div>
</template>

<script>
import BreadCrumbs from '@/components/home/breadCrumbs'
import Content from './siderContent-01'
export default {
  name: 'announcement',
  components: {
    BreadCrumbs,
    Content
  }
}
</script>

<style scoped lang='less'>

</style>



// WEBPACK FOOTER //
// src/components/home/search/index.vue